<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="Home Banner" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Banner</label>
                                        <div>
                                            <img v-if="show_image" style="width: 250px; border-radius: 6px;" :src="show_image">
                                            <input :class="show_image ? 'ml-4' : 'ml-0'" type="file" accept="image/*" @change="uploadImage">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Title</label>
                                                    <input class="form-control" type="text" v-model="home.banner.title" placeholder="Enter banner title" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label>Short Description</label>
                                                    <b-form-textarea class="form-control" type="text" v-model="home.banner.description" placeholder="Enter short description" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <b-button @click="handleSubmit">Submit</b-button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Container-fluid Ends-->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    myHost
} from '../../../_helpers/host';
import {
    mapState
} from 'vuex';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            home: {
                image: null,
                banner: {
                    title: null,
                    description: null
                }
            },
            show_image: null
        };
    },

    computed: {
        ...mapState({
            new_banner: state => state.about.banner,
            loading: state => state.about.bannerLoading,
            error: state => state.about.bannerError
        })
    },

    watch: {
        new_banner(oldValue, newValue) {
            this.home.banner.title = this.new_banner.banner.title
            this.home.banner.description = this.new_banner.banner.description
            this.show_image = this.host + this.new_banner.image
        }
    },

    mounted() {
        this.$store.dispatch("about/fetchBanner")
    },

    methods: {
        uploadImage(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.home.image = e.target.result
                this.show_image = e.target.result
            };
        },

        handleSubmit() { 
            this.$store.dispatch("about/addBanner", this.home).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
